import * as R from 'ramda';

export function urlParamsToObject(urlSearchParams) {
  return R.fromPairs(Array.from(urlSearchParams.entries()));
}
